import { defineMessages, MessageDescriptor } from 'react-intl';

export const messagesSpinToWin: Record<string | number | symbol, MessageDescriptor> = defineMessages({
  'spinToWinGame:title': {
    id: 'spinToWinGame:title',
    defaultMessage: 'Spin To Win!',
    description: 'Game view title',
  },
  'spinToWinGame:button': {
    id: 'spinToWinGame:button',
    defaultMessage: 'Spin The Wheel!',
    description: 'Game view button label',
  },
  'spinToWinGame:win-popup-title': {
    id: 'spinToWinGame:win-popup-title',
    defaultMessage: 'Amazing! You won!',
    description: 'Win popup title',
  },
  'spinToWinGame:win-popup-description': {
    id: 'spinToWinGame:win-popup-description',
    defaultMessage:
      'Redeem your prize at any {vendor} Rewards location by typing in your phone number at the cash register!',
    description: 'Win popup description',
  },
  'spinToWinGame:win-popup-button': {
    id: 'spinToWinGame:win-popup-button',
    defaultMessage: 'AWESOME!',
    description: 'Win popup button label',
  },
  'spinToWinGame:terms-and-conditions': {
    id: 'spinToWinGame:terms-and-conditions',
    defaultMessage:
      'Valid while supplies last. Void where prohibited.\nTerms & Conditions apply. [Terms & Conditions]({termsAndConditionsLink})',
    description: 'Game Terms & Conditions',
  },
  'spinToWinGame:wheel-spin': {
    id: 'spinToWinGame:wheel-spin',
    defaultMessage: 'SPIN!',
    description: 'Wheel sector SPIN label',
  },
  'spinToWinGame:wheel-no-lock': {
    id: 'spinToWinGame:wheel-no-lock',
    defaultMessage: 'NO LUCK',
    description: 'Wheel sector NO LUCK label',
  },
});
